export const filterPrimaryProcedures = (procedures = []) => {
  return procedures?.filter(
    (procedure) =>
      procedure?.type === 'primary' && procedure?.procedure_code && !procedure?.invoiceId
  );
};
